var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scroller",
      staticClass: "items-end flex w-full flex-col z-60 relative",
      style: { height: _vm.scroller_height + "px" }
    },
    [
      _c(
        "div",
        {
          staticClass: "scroll-wrapper gap-32",
          style: { position: _vm.scroll_pos }
        },
        _vm._l(_vm.items, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "bg-white p-24 lg:p-[50px] mb-24 lg:mb-[50px] lg:w-[600px] xl:w-[800px] selector-card flex-row flex gap-32"
            },
            [
              _vm.$mq !== "sm"
                ? _c("div", { staticClass: "text-orange font-bold text-50" }, [
                    _vm._v(_vm._s(index + 1))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "text-orange text-30 mb-16 font-regular" },
                  [_vm._v(_vm._s(item.title))]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "rte",
                  domProps: { innerHTML: _vm._s(item.description) }
                }),
                _vm._v(" "),
                item.link && item.link.url
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "cta px-[25px] py-[14px] items-center gap-8 font-semi group hover:opacity-75 transition-opacity inline-flex",
                        class: item.link.class,
                        attrs: {
                          target:
                            item.link.target == "0" || item.link.target == ""
                              ? "_self"
                              : "_blank",
                          href: item.link.url
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.link.title) +
                            "\n                    "
                        ),
                        item.link.class.includes("bg-white")
                          ? _c("i", {
                              staticClass:
                                "fas fa-chevron-right text-12 text-brown-400 group-hover:mr-[-8px] group-hover:ml-[8px] transition-all"
                            })
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }